import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useSelector } from "react-redux";
import { introText } from "../../i18n/intro";
import { useNavigate } from "react-router-dom";
import ImageSlider from "Util/ImageSlider";

const MissionAdvisory = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = introText[lang];
  const navigate = useNavigate();

  const slides = [
    "/maria/banner/MP1.png",
    "/maria/banner/MP3.png",
    "/maria/banner/MP4.png",
    "/maria/banner/MP5.png",
    "/maria/banner/MP6.png",
    "/maria/banner/MP7.png",
  ];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="hidden lg:block relative w-full ">
        <ImageSlider slides={slides} variant="desktop" />
      </div>

      {/* ===== MOBILE GRID VERSION ===== */}
      <div className="lg:hidden flex ">
        <ImageSlider slides={slides} variant="mobile" />
      </div>
    </section>
  );
};

export default MissionAdvisory;
